import {BaseTextInput} from "../../../../../Common/Component/Input/BaseTextInput";
import {BaseCheckboxInput} from "../../../../../Common/Component/Input/BaseCheckboxInput";
import {BaseCalendarInput} from "../../../../../Common/Component/Input/BaseCalendarInput";
import BooleanSelector, {BOOLEAN_SELECTOR} from "../../../../../Common/Component/Select/BooleanSelector";
import {useState} from "react";



export function DefaultColumnFilter({header}) {

    const column = header.column;
    const [_value, setValue] = useState('');
    const [_timeout, _setTimeout] = useState(0);


    const delayInput = (e) => {
        setValue(e.target.value);

        if (_timeout) {
            console.log('limpando..')
            clearTimeout(_timeout);
        }

        let timeout = setTimeout(() => {
            console.log('filtrando..')
            column.setFilterValue(e.target.value);
        }, 500);

        _setTimeout(timeout);
    }


    return (
        <BaseTextInput
            label={column.columnDef.header}
            labelRequired={true}
            value={_value}
            showFormComponents={false}
            onChange={e => delayInput(e)}
            placeholder={`Filtrar resultados...`}
        />
    )
}

export function DefaultColumnFilterSelector({header}) {

    const column = header.column;
    const Selector = header.column.columnDef.customFilterSelectorElement;
    const [value, setValue] = useState(null);


    return <Selector entitySchema={header.column.columnDef.entitySchema} showCreateButton={false} title={header.column.columnDef.header}
                     value={value} setFilterColumn={column.setFilterValue} setValue={setValue}/>
}

export function InputNumberColumnFilter({header}) {

    const column = header.column;
    const [_value, setValue] = useState('');
    const [_timeout, _setTimeout] = useState(0);


    const delayInput = (e) => {
        setValue(e.target.value);

        if (_timeout) {
            console.log('limpando..')
            clearTimeout(_timeout);
        }

        let timeout = setTimeout(() => {
            console.log('filtrando..')
            column.setFilterValue(e.target.value);
        }, 500);

        _setTimeout(timeout);
    }

    return (
        <BaseTextInput
            label={column.columnDef.header}
            labelRequired={true}
            type="number"
            value={_value}
            showFormComponents={false}
            onChange={e => delayInput(e)}
            placeholder={`Filtrar resultados...`}
        />
    )
}


export function BooleanSelectorColumnFilter({header}) {

    const column = header.column;
    const [_value, setValue] = useState(BOOLEAN_SELECTOR[2]);

    return (<BooleanSelector
        title={column.columnDef.header}
        labelRequired={true}
        showFormComponents={false}
        value={_value}
        setValue={x => {
            setValue(x);
            column.setFilterValue(x.id)
        }}
        placeholder={`Filtrar resultados...`}
    />)
}


export function CheckboxColumnFilterV2({header}) {

    const column = header.column;
    const value = column.getFilterValue();

    return (<BaseCheckboxInput
        label={column.columnDef.header}
        labelRequired={true}
        showFormComponents={false}
        checked={!!value}
        onChange={e => column.setFilterValue(e.target.checked)}
        placeholder={`Filtrar resultados...`}
    />)
}


export function CheckboxColumnFilter({column}) {

    const value = column.getFilterValue();

    return (<BaseCheckboxInput
        label={column.columnDef.header}
        labelRequired={true}
        showFormComponents={false}
        checked={!!value}
        onChange={e => column.setFilterValue(e.target.checked)}
        placeholder={`Filtrar resultados...`}
    />)
}

export function DateRangeColumnFilter({column}) {

    const value = column.getFilterValue();

    return (<BaseCalendarInput
        label={column.columnDef.header}
        labelRequired={true}
        defaultValue={value}
        selectionMode="range"
        onChange={e => column.setFilterValue(e)}
        placeholder={`Filtrar resultados...`}
    />)
}

export function DateColumnFilter({column}) {

    const value = column.getFilterValue();

    return (<BaseCalendarInput
        label={column.columnDef.header}
        labelRequired={true}
        defaultValue={value}
        // selectionMode="range"
        onChange={e => {
            if (e) {
                e.onlyDate = true;
            }
            column.setFilterValue(e);
        }}
        placeholder={`Filtrar resultados...`}
    />)
}
